import { css } from 'styled-components';

export const glassPanelBase = css`
  color: #fff;
  border: 1px solid rgba(148, 163, 184, 0.28);
  background: rgba(10, 10, 12, 0.62);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(10px);
  font-family: 'DM Sans', -apple-system, sans-serif;
`;

export const mutedPanelTitle = css`
  color: #94a3b8;
  font-weight: 700;
`;

export const glassPillButtonBase = css`
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  color: #94a3b8;
  background: rgba(10, 10, 12, 0.62);
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  &:hover {
    background: rgba(30, 41, 59, 0.55);
    border-color: rgba(148, 163, 184, 0.5);
    color: #cbd5e1;
  }
`;
